module.exports = __webpack_public_path__ + "img/government-Industry-points3.c80dd403.png";